// externals
import { connect } from 'react-redux';

// selectors
import * as tradeInSelectors from '../../../store/mmd/tradeIn';

// actions
import * as tradeInActionCreators from '../../../store/actionCreators';

// consts/enums
import * as tradeInRoutes from '../../../utils/routes';
import { processStepperRoutes } from '../../../utils/tradeInDecisionLogic';
import { LOAN_BALANCE_TRADE_IN_STEP, STEPPER_ROUTES, stepperRouteMap } from '../../../utils/constants';
import { isShowroomExperience } from '../../../utils/configUtils';

// components

// interfaces/types
import { IAutoLoanUnavailableUIDispatchProps, IAutoLoanUnavailableUIStateProps } from './AutoLoanUnavailableInterfaces';
import { IRootProps } from '../../../components/RootProps';
import { StepperRoute } from '../../../types';
import AutoLoanUnavailableUI from './AutoLoanUnavailableUI';

const mapStateToProps = (state: any, ownProps: IRootProps): IAutoLoanUnavailableUIStateProps => {
    const { tradeIn } = tradeInSelectors.getTradeInState(state, ownProps.tradeIndex);
    const isAmdLienPayoffQuoteSpOnSPEnabled = tradeInSelectors.isAmdLienPayoffQuoteEnabled(state);
    const { vehicle } = tradeIn;

    const vehicleName = `${vehicle.year} ${vehicle.make.name} ${vehicle.model.name}`;

    const pageTitle = 'Trade-In Vehicle';
    const pageSubTitle = 'Determine how much your current vehicle, is worth, and apply that value to your new vehicle.';

    const isSalesView = isShowroomExperience(ownProps.config);
    const tradeInSource = tradeIn?.source;

    const selectedStepperRoute: StepperRoute[] = stepperRouteMap[tradeInSource] || STEPPER_ROUTES.loanBalance;
    const stepperRoutes = processStepperRoutes(
        state,
        selectedStepperRoute,
        isSalesView,
        isAmdLienPayoffQuoteSpOnSPEnabled,
        ownProps.tradeIndex,
        'Loan Balance',
        tradeInRoutes.TRADE_AUTO_LOAN_UNAVAILABLE
    );

    return {
        vehicle,
        vehicleName,
        pageTitle,
        pageSubTitle,
        stepperRoutes,
        tradeInSource,
        urlPath: ownProps.tradeInRoute
    };
};

const mapDispatchToProps = (dispatch: any): IAutoLoanUnavailableUIDispatchProps => {
    return {
        dispatchAnalytics: (type: string, description: string) => {
            dispatch(tradeInActionCreators.dispatchAnalytics(type, description));
        },
        goToRoute: (route: string) => {
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(route));
        },
        next: () => {
            dispatch(tradeInActionCreators.cdlEstimateBalanceButtonClicked());
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(tradeInRoutes.TRADE_ESTIMATE_LOAN_BALANCE));
        },
        goBack: () => {
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(tradeInRoutes.TRADE_FIND_OPEN_LOAN));
        },
        removeTrade: () => {
            // fire CDL analytics for cancel, then remove trade and route to the trade-in start
            dispatch(tradeInActionCreators.cdlCancelTradeInButtonClicked(LOAN_BALANCE_TRADE_IN_STEP));
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(tradeInRoutes.TRADE_IN));
            dispatch(tradeInActionCreators.removeTradeIn());
        },
        cdlPageView: () => {
            dispatch(tradeInActionCreators.cdlLoanBalanceNotFoundPageView());
        },
        cdlBackButtonClicked: () => {
            dispatch(tradeInActionCreators.cdlBackButtonClicked(LOAN_BALANCE_TRADE_IN_STEP));
        },
        cdlCancelTradeInButtonClicked: () => {
            dispatch(tradeInActionCreators.cdlCancelTradeInButtonClicked(LOAN_BALANCE_TRADE_IN_STEP));
        }
    };
};

const AutoLoanUnavailable = connect(mapStateToProps, mapDispatchToProps)(AutoLoanUnavailableUI);

export default AutoLoanUnavailable;
